module.exports = __webpack_public_path__ + "static/media/breedCut-02.3ef2a4cd.png";